module.exports = function() {
  return new Worker(__webpack_public_path__ + "c6fb91d9dcc223bbb288.worker.js");
};